/**
 * Helpers for the first transition to won.
 * firstWonAt is write-once; closedAt may still be edited manually later.
 */

export function shouldSetFirstWonAt(existing: {
  firstWonAt?: unknown;
}): boolean {
  return existing.firstWonAt == null || existing.firstWonAt === '';
}

/** Already-won deals: sync value only — never touch closedAt / firstWonAt. */
export function wonDealValueOnlyUpdate(value: number): { value: number } {
  return { value };
}

export function isAlreadyWonDeal(deal: { outcome?: unknown }): boolean {
  return String(deal.outcome || '').toLowerCase() === 'won';
}
